export enum QuestionnaireLanguage {
  enUS = 'en_US',
  esES = 'es_ES',
}